/**
 * ModelUsage.tsx — Analytics / Model Usage page.
 *
 * Per-model token/cost analytics are not exposed on the tenant API (billing
 * usage lives behind an operator-scoped endpoint), so this view shows an honest
 * "coming soon" state rather than fabricated token counts.
 */
import { SectionTitle, ComingSoon } from '../DashboardShared'

export function ModelUsage() {
  return (
    <div className="page-enter flex flex-col gap-6">
      <SectionTitle title="Model Usage" subtitle="Token consumption and cost breakdown by model" />
      <ComingSoon
        module="Model usage analytics"
        description="Per-model token and cost breakdowns are not yet exposed on the tenant API. This view will populate once the usage endpoint is available."
      />
    </div>
  )
}
